/**
 * Utility functions for Openlayers vector/layers
 */
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Geometry, {Type} from "ol/geom/Geometry.js";
import {Feature} from "ol";

function toSource<T extends Geometry>(v: VectorSource|VectorLayer<VectorSource<T>>): VectorSource {
    return v instanceof VectorLayer ? v.getSource() : v;
}

function toFeatures<T extends Geometry>(v: VectorSource|VectorLayer<VectorSource<T>>): Feature[] {
    return toSource(v).getFeatures();
}

const POLYGON_AND_MULTIPOLYGON: Type[] = [
    'Polygon', 'MultiPolygon'
];
function hasPolyGeometry(f: Feature) {
    return POLYGON_AND_MULTIPOLYGON.includes(f.getGeometry().getType());
}

export function hasPolygons<T extends Geometry>(v: VectorSource|VectorLayer<VectorSource<T>>): boolean {
    return toFeatures(v).some(hasPolyGeometry);
}

const POINT_AND_MULTIPOINT: Type[] = [
    'Point', 'MultiPoint'
];
function hasPointGeometry(f: Feature) {
    return POINT_AND_MULTIPOINT.includes((f.getGeometry().getType()));
}

export function hasPoints<T extends Geometry>(v: VectorSource|VectorLayer<VectorSource<T>>): boolean {
    return toFeatures(v).some(hasPointGeometry);
}

const LINE_AND_MULTI_LINE: Type[] = [
    'LineString', 'MultiLineString'
];

function hasLineGeometry(f: Feature) {
    return LINE_AND_MULTI_LINE.includes((f.getGeometry().getType()));
}

export function hasLines<T extends Geometry>(v: VectorSource|VectorLayer<VectorSource<T>>): boolean {
    return toFeatures(v).some(hasLineGeometry);
}